import { Mail } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface EmailConfirmationBannerProps {
  email?: string;
  /** Visual variant for dark (gradient) backgrounds vs light card backgrounds */
  variant?: "light" | "dark";
  className?: string;
}

/**
 * Persistent, non-dismissable banner shown after signup to remind
 * the user to confirm their email address.
 */
export function EmailConfirmationBanner({
  email,
  variant = "light",
  className = "",
}: EmailConfirmationBannerProps) {
  const isDark = variant === "dark";

  return (
    <Alert
      className={`border ${
        isDark
          ? "bg-white/10 border-white/20 text-white"
          : "bg-primary/5 border-primary/20 text-foreground"
      } ${className}`}
    >
      <Mail className={`h-5 w-5 ${isDark ? "text-white" : "text-primary"}`} />
      <AlertTitle className={`font-semibold ${isDark ? "text-white" : ""}`}>
        Check your email
      </AlertTitle>
      <AlertDescription className={isDark ? "text-white/80" : ""}>
        We sent a confirmation link to{" "}
        {email ? <span className="font-medium">{email}</span> : "your email"}.
        Please click the link to verify your account before signing in.
      </AlertDescription>
    </Alert>
  );
}
